import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

export const useNextPageBoxTracking = (regionsName?: string) => {
    const shareData = {
        event: "tile_find_for_you",
        event_category: regionsName ?? ""
    };

    const onButtonClick = (label: string) => {
        const data = {
            ...shareData,
            event_label: label,
            event_action: "click"
        };

        hitGoogleTagManager(data);
    };
    const onView = () => {
        const data = {
            ...shareData,
            event_action: "view"
        };

        hitGoogleTagManager(data);
    };

    return {onView, onButtonClick};
};
import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

export const useNextPageBoxTracking = (regionsName?: string) => {
    const shareData = {
        event: "tile_find_for_you",
        event_category: regionsName ?? ""
    };

    const onButtonClick = (label: string) => {
        const data = {
            ...shareData,
            event_label: label,
            event_action: "click"
        };

        hitGoogleTagManager(data);
    };
    const onView = () => {
        const data = {
            ...shareData,
            event_action: "view"
        };

        hitGoogleTagManager(data);
    };

    return {onView, onButtonClick};
};
